import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { useCallback } from 'react';
export const useVoucherEligibleTld = function (enabled) {
  var _account$coupons;
  if (enabled === void 0) {
    enabled = true;
  }
  const {
    data: tldsData
  } = DomainsApiClient.hooks.useDomainTlds({
    disableGeoFiltering: true
  }, enabled, {
    staleTime: Infinity,
    cacheTime: Infinity,
    useErrorBoundary: false
  });
  const {
    data: account
  } = DomainsApiClient.hooks.useDomainsAccount({}, enabled, {
    staleTime: Infinity,
    cacheTime: Infinity,
    useErrorBoundary: false
  });
  const supported = ((tldsData == null ? void 0 : tldsData.tlds) ?? []).filter(_ref => {
    let {
      couponsApplicable
    } = _ref;
    return couponsApplicable;
  }).map(_ref2 => {
    let {
      tld
    } = _ref2;
    return tld;
  }).join(',');
  const promotesFreeYear = !(account != null && account.isPremiumSite) || Boolean(account == null || (_account$coupons = account.coupons) == null ? void 0 : _account$coupons.length);
  return useCallback((tld, premium) => Boolean(tld) && !premium && promotesFreeYear && supported.split(',').includes(tld), [supported, promotesFreeYear]);
};
//# sourceMappingURL=useVoucherEligibleTld.js.map